import React, { Component } from 'react';
import './App.css';

import { BrowserRouter, Route } from 'react-router-dom'

// レイアウトコンポーネント読み込み
import Header from './layouts/Header'

// ページコンポーネント読み込み
import Home from './pages/Home'
import Search from './pages/Search'
import MyPage from './pages/MyPage'

// コンポーネント読み込み
import VisitedSpotDetail from './pages/VisitedSpotDetail'

// Wikiデータ読み込み
import spotListData from './WikiData'

// 文字列>ブーリアン 変換
function str2bool(string) {
  if (string === 'true') {
    return true
  } else {
    return false
  }
}

class App extends Component {

  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      spotList: null
    }
    this.changeSpotListState = this.changeSpotListState.bind(this)
  }

  // DOM描画後の処理
  componentDidMount() {
    let dataExist = localStorage.getItem('dataExist');
    let newSpotList = []
    if (dataExist === 'yes' ) {
      newSpotList = this.updateLocalStorageSpotList(spotListData)
      this.setState({spotList: newSpotList})
    } else { // 存在しない場合はストレージを更新し，データをそのまま取得
      // ナビゲーションを表示？
      this.initLocalStorageSpotList(spotListData)
      this.setState({spotList: spotListData})
    }
  }

  // ローカルストレージを初期化
  initLocalStorageSpotList(spotList) {
    for (let i=0; i < spotList.length; i++) {
      localStorage.setItem(spotList[i].key, spotList[i].visited);
    }
    localStorage.setItem('dataExist', 'yes');
  }

  // ローカルストレージを更新
  updateLocalStorageSpotList(spotList) {
    let updatedSpotList = []
    for (let j=0; j < spotList.length; j++) {
      // スポットリストをコピー
      updatedSpotList.push(Object.assign({}, spotList[j]))
      // スポットの訪問状況を取得
      updatedSpotList[j].visited = str2bool(localStorage.getItem(spotList[j].key));
    }
    return updatedSpotList
  }

  // スポットの訪問状況を更新
  changeSpotListState(selectedSpot) {
    let {spotList} = this.state
    for (let i=0; i < spotList.length; i++) {
      // 観光スポットのリストから選択されたスポットを探す
      if (spotList[i].key === selectedSpot.key) {
        // 訪問済みなら未訪問に
        if (selectedSpot.visited) {
          spotList[i].visited = false
          selectedSpot.visited = false
          localStorage.setItem(selectedSpot.key, false)
        } // 未訪問なら訪問済みにステータスを変更
        else {
          spotList[i].visited = true
          selectedSpot.visited = true
          localStorage.setItem(selectedSpot.key, true)
        }
      }
    }
    this.setState({
      spotList: spotList
    })
  }

  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <div>
            <Header />
            <Route exact path='/' component={Home} />
            <Route path='/search' render={props => <Search spotList={this.state.spotList} changeSpotListState={this.changeSpotListState} />} />
            <Route exact path='/mypage' render={props => <MyPage spotList={this.state.spotList} />} />
            <Route path='/mypage/spot/:id' render={props => <VisitedSpotDetail spotList={this.state.spotList} match={props.match} />} />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
